import { render, staticRenderFns } from "./SubPanelPaymentMethods.vue?vue&type=template&id=24c6579e&scoped=true&"
import script from "./SubPanelPaymentMethods.vue?vue&type=script&lang=ts&"
export * from "./SubPanelPaymentMethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6579e",
  null
  
)

export default component.exports